import { formatURIComponent } from './utils'

export default (instance:string) => {
    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}`
    }
    return [{
        pageLayout: 'tabs',
        pageTitle: '我的华美云',
        icons: [
        { 
            name: '关注酒店',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/hotel`),
            path: "我的"
        },
        { 
            name: '关注城市',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/city`),
            path: "我的"
        },
        { 
            name: '关注品牌',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/brand`),
            path: "我的"
        },
        { 
            name: '关注集团',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/group`),
            path: "我的"
        },
        { 
            name: '关注研报',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/file`),
            path: "我的"
        },
        { 
            name: '华美服务',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/内容文件/华美/华美简介`),
            path: "我的"
        },
        
    ]}]
}